import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import items from './widgets/items';
import copyItems from './widgets/copy-items';
import draft from './widgets/draft';
import isMaintenance from './widgets/is-maintenance';

const widgets = combineReducers({
  items,
  copyItems,
  draft,
  isMaintenance,
  isLoading: loadingStatusAccordingToReducer('widgetsLoadingStatus'),
});

export default widgets;



// WEBPACK FOOTER //
// ./src/modules/app/reducers/widgets.reducer.js